module.exports = __webpack_public_path__ + "static/media/support_email_icon.65f90882.svg";